<template>

  <RiepilogoInsolutiAgenti />
 
</template>

<script>
import RiepilogoInsolutiAgenti from '../components/pratiche/RiepilogoInsolutiAgenti.vue'

export default {
  pageName: '',
  components: {
    RiepilogoInsolutiAgenti

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
